export default __webpack_public_path__ + "images/ef7666d8cfe3a81890e1a67120d2e1d0.svg";